import { SharedState } from 'app/types-shared';

export const getExperienceTransferAdminAccess =
  (sharedState: SharedState): boolean => sharedState?.access?.adminPanel?.experienceTransfer?.administrationCentral;
